import React, { FC } from 'react'
import { PendingProcessHearingType } from 'types/pending-process-hearing.type'
import {
  StyledCardProcessHearing,
  StyledCardStatus,
  StyledCardTitleCategory,
} from 'pages/PendingProcessHearing/styles'
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'
import VisibilityIcon from '@mui/icons-material/Visibility'
import dayjs from 'dayjs'
import { cnjMask } from 'utils/mask.util'
import { getCategoryBorderColor, getStatusBackgroundColor } from 'pages/PendingProcessHearing'
import { STATUS_OPTIONS } from 'pages/ViewPendingProcessHearing'

export const CardProcessHearing: FC<{
  data: PendingProcessHearingType
  onNavigate: (data: PendingProcessHearingType) => void
}> = ({ data, onNavigate }) => {
  return (
    <StyledCardProcessHearing>
      <Stack direction={'column'} spacing={1}>
        <Box
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
            <StyledCardTitleCategory
              sx={{
                borderColor: getCategoryBorderColor(data.categoria),
              }}
            >
              <Typography variant={'body2'}>
                <b>{data.categoria}</b>
              </Typography>
            </StyledCardTitleCategory>
            <Typography variant={'body2'}>
              <b>{data.numeroProcesso}</b>
            </Typography>
          </Box>
          {data.notificacoes && data.notificacoes.length > 0 && (
            <Tooltip
              title={
                <div>
                  {data.notificacoes.map((notificaco, i) => (
                    <div key={i}>{notificaco}</div>
                  ))}
                </div>
              }
            >
              <WarningIcon sx={{ color: '#fbc02d' }} />
            </Tooltip>
          )}
        </Box>
        <Stack direction={'row'} alignItems={'center'}>
          <Tooltip title='Ver detalhes do processo.' placement={'top'}>
            <IconButton
              size='small'
              onClick={() => {
                onNavigate(data)
              }}
            >
              <VisibilityIcon fontSize='inherit' />
            </IconButton>
          </Tooltip>
        </Stack>
        <Typography variant={'button'}>
          {dayjs(data.dataRecebimento).format('DD/MM/YYYY')}
        </Typography>
        <Stack direction={'column'}>
          <Typography variant={'body2'}>
            <b>Número CNJ: </b>
            {cnjMask(data.numeroCnj)}
          </Typography>
          <Typography variant={'body2'}>
            <b>Delegacia de Circunscrição do Fato: </b>
            {data.delegaciaCircunscricaoFato}
          </Typography>
        </Stack>
        <Box display={'flex'}>
          <StyledCardStatus
            sx={{
              backgroundColor: getStatusBackgroundColor(data.status),
            }}
          >
            <small>
              <b>{STATUS_OPTIONS[data.status]}</b>
            </small>
          </StyledCardStatus>
        </Box>
      </Stack>
    </StyledCardProcessHearing>
  )
}
